export default {
  'header.menu.purpose': '協会紹介と目的',
  'header.menu.join': '協会規則と入会案内',
};
